module.exports = __webpack_public_path__ + "assets/img/de-a9abd49e.png";